import { Title } from "dash-styled"
import { FC } from "react"
import { Helmet } from "react-helmet-async"

export const TemplateNotFound: FC = () => {
    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
            </Helmet>
            <div className="w-full h-full flex flex-col justify-end items-center">
                <div className="flex-1 flex justify-end items-center">
                    <Title
                        component="h1"
                        weight="semibold"
                        color="violet"
                        variant="heading1"
                        className="text-xl lg:text-profile-header mb-4"
                    >
                        The template you are looking for is not available
                    </Title>
                </div>
            </div>
        </>
    )
}
